var map = {
	"./agco.png": "dbef",
	"./background.jpg": "1100",
	"./background.png": "30b3",
	"./dealogic.png": "5726",
	"./epam.png": "fbd0",
	"./grape-solutions.png": "c15f",
	"./its_me.jpg": "caeb",
	"./logo.png": "cf05",
	"./logo.svg": "9b19",
	"./sei.png": "96dc",
	"./student.png": "19a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";